<template>
    <div class="container">
        <div class="item-headder">
            <div>
                <h2>New case<span v-if="!(caseInfo.title == '' || caseInfo.title == null)">: {{caseInfo.title}}</span></h2>
            </div>
        </div>
        <h2>Case details</h2>
        <div class="div-table row">
            <div>
                <p>Customer</p>
                <span>
                    {{userInfo.name}}
                </span>
            </div>
            <div>
                <p>Title</p>
                <span>
                    <input type="text" maxlength="255" v-model="caseInfo.title"/>
                </span>
            </div>
            <div>
                <p>Department</p>
                <span>
                    <select v-model="caseInfo.department">
                        <option :value="null">No department</option>
                        <option v-for="department in departments" :value="department.id" :key="department.id">
                            {{department.title}}
                        </option>
                    </select>
                </span>
            </div>
            <div>
                <p>Product</p>
                <span>
                    <select v-model="caseInfo.product">
                        <option :value="null">No product</option>
                        <option v-for="userproduct in userproducts" :value="userproduct.supportid" :key="userproduct.supportid">
                            {{userproduct.supportid}} - {{userproduct.description}}
                        </option>
                    </select>
                </span>
            </div>
            <div>
                <p>Assignee</p>
                <span>
                    <select v-model="caseInfo.assignee">
                        <option :value="null">No assignee</option>
                        <option v-for="assignee in assignees" :value="assignee.id" :key="assignee.id">
                            {{assignee.name}}
                        </option>
                    </select>
                </span>
            </div>
        </div>
        <h2>First message</h2>
        <div class="new-message">
            <p class="message-content" id="message-content" contenteditable="true" placeholder="Write a new message..."></p>
            <div class="action-panel">
                <div class="btn" v-on:click="createCase()">Send</div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .new-message{
        border-radius: 5px;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        padding: 1.5rem;
        background-color: var(--bg-color-3);
        transition: background-color 300ms ease, box-shadow 300ms ease;
        &:hover, &:focus, &:focus-within{
            background-color: var(--bg-color-4);
            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
        }
        margin-bottom: 3rem;
        .message-content{
            min-height: 3rem;
            margin-top: 0;
        }
        .action-panel{
            margin-top: 1rem;
            border-top: 1px solid rgba(gray, 0.4);
            padding-top: 10px;
        }
    }
</style>
<script>
export default {
    name: 'CreateCase',
    data() {
        return {
            caseInfo: {
                department: null,
                product: null,
                assignee: null,
                title: null,
                status: 'agent_waiting',
            },
            userInfo: {},
            caseMessageInfo: [],
            editDetails: 0,
            answer: {
                message: '',
                type: '',
            },
            departments: [],
            assignees: [],
            userproducts: [],
            smsmodal: 0,

        }
    },
    methods: {
        withBrTags: function(data) {
            return data.replace(/(\\r)*\\n/g, '<br>')
        },
        baseToText(base){
            return atob(base);
        },
        createCase(){
            var vue = this;
            var message = document.getElementById("message-content").innerText;
            if(message && vue.caseInfo.title && vue.caseInfo.department){
                message += "</br></br>Med venlig hilsen</br>"+this.formatName(this.$store.state.account.name)+"";
                this.$socket.client.emit('createCase',{message: message, user:vue.userInfo.id,subject:vue.caseInfo.title,department: vue.caseInfo.department,status:vue.caseInfo.status,product:vue.caseInfo.product,assignee: vue.caseInfo.assignee}, (error, response) => {
                    if(error=='200'){
                        vue.$router.push('/cases/'+response);
                    }else{
                        console.log("JESUS C");
                    }
                })
            }
        },
        formatName(name){
            var namearray = name.split(" ");
            return namearray[0] + " " +namearray[namearray.length-1].charAt(0)+'.';
        },
        getCaseData(){
            var vue = this;
            this.$socket.client.emit('getUserInfo',vue.$route.params.uniqueid, (error, response) => {
                if(error=='200'){
                    vue.userInfo = response;
                    
                    vue.$socket.client.emit('getUserProducts',vue.$route.params.uniqueid, (error, response) => {
                        if(error=='200'){
                            vue.userproducts = response;
                        }
                    })
                }
            })
            this.$socket.client.emit('getCaseDepartments',null, (error, response) => {
                if(error=='200'){
                    vue.departments = response;
                }
            })
            this.$socket.client.emit('getAssigneeCases',null, (error, response) => {
                if(error=='200'){
                    vue.assignees = response;
                }
            })
        },
        dateTimeFormat : function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        }
    },
    mounted() {
        this.getCaseData();
    },
}
</script>